import StyledModal from '@/components/StyledModal';
import { Button, ModalBody, ModalFooter, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  title: string;
  message: string;
  cancelText?: string;
  confirmText?: string;
  confirmVariant?: string;
  onCancel: () => void;
  onConfirm: () => void;
  modalSize?: string;
  messageSize?: string;
  isButtonConfirmLoading?: boolean;
  children?: JSX.Element;
};

const DialogModal = ({
  isOpen,
  title,
  message,
  cancelText,
  confirmText,
  confirmVariant = 'primary',
  onCancel,
  onConfirm,
  modalSize = 'xl',
  messageSize = 'lg',
  isButtonConfirmLoading = false,
  children,
}: Props) => {
  const { t } = useTranslation('DialogModal');
  const cancel = cancelText || t('buttons.cancel');
  const confirm = confirmText || t('buttons.ok');
  return (
    <StyledModal isOpen={isOpen} onClose={onCancel} size={modalSize} title={title}>
      <ModalBody>
        <Text color="text-secondary" fontSize={messageSize} fontWeight={500} whiteSpace="pre-line">
          {message}
        </Text>
        {children}
      </ModalBody>
      <ModalFooter>
        <Button isDisabled={isButtonConfirmLoading} onClick={onCancel} size="lg" variant="secondary">
          {cancel}
        </Button>
        <Button isLoading={isButtonConfirmLoading} onClick={onConfirm} size="lg" variant={confirmVariant}>
          {confirm}
        </Button>
      </ModalFooter>
    </StyledModal>
  );
};

export default DialogModal;
